export const API_VERSIONS = ["V2.0", "V1.0"];

export const TECHNICAL_INDICATORS = [
  "SMA", "EMA", "RSI", "WMA", "MMA", "DEMA", "TEMA", "ZLEMA", "UlcerIndex", "ROC", "HMA", "CMO",
  "StochasticRSI", "VWAP", "ADX", "CCI", "StochasticOscillatorK", "AROONDOWN", "AROONUP", "WilliamsR", "RWILow", "RWIHigh", "DPO", "ATR",
  "MACD", "BBANDSM", "KAMA", "PPO", "CoppockCurve", "OBV", "ParabolicSar", "Fisher", "ChandelierExitShort", "ChandelierExitLong"
];

export const EVENT_GENRE = [
  "M&A", "partnership", "credit market", "expansion", "funding", "analyst estimate", "data leak", "product release", "regulatory", "blockchain",
  "fraud", "lawsuit", "charity", "education", "philanthropy", "retail", "analyst rating", "bankruptcy", "international affairs",
  "cyber security", "antitrust", "corruption", "tariff", "environment", "earnings", "labor market", "fixed income", "food",
  "commodities", "media", "climate change", "startup", "autonomous car", "achievement", "corporate leadership", "investment", "pharmaceutical",
  "energy market", "equities", "financing", "valuation", "intellectual property", "currencies", "market performance", "taxation", "economic data",
  "cloud computing", "trade", "central bank", "product", "automotive", "machine learning", "recession", "emerging market", "technical analysis"
];

export const EVENT_SECTOR = [
  "healthcare", "energy", "basic materials", "industrials", "technology", "financial services",
  "communication services", "consumer cyclical", "consumer defensive", "utilities", "real estate"
];

export const FOREX_LIST = ['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BCH', 'BDT', 'BGN', 'BHD',
  'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BTC', 'BWP', 'BZD', 'CAD', 'CDF', 'CHF', 'CLF', 'CLP', 'CNY', 'COP', 'CRC', 'CUP', 'CVE',
  'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ETB', 'ETH', 'EUR', 'FJD', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD',
  'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KRW', 'KWD',
  'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LTC', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MOP', 'MRO', 'MUR', 'MVR', 'MWK',
  'MXN', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON',
  'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SLL', 'SOS', 'SRD', 'SVC', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP',
  'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'UYU', 'UZS', 'VEF', 'VND', 'XAF', 'XCD', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMW', 'USD'];

export const EXCHANGE_LIST = ["AEX", "AMEX", "ASX", "BATS", "BCBA", "BIST", "BOM", "BSE", "CNQ", "DOH", "FRA", "GER", "HKEX", "JSE",
  "JSX", "KLS", "KSC", "LSE", "MAD", "MCX", "MEX", "MIL", "NASDAQ", "NSE", "NYSE", "NYSEARCA", "NZX", "OMX", "OMXC", "OMXH", "OMXI",
  "OMXR", "OMXT", "OMXV", "OTCMKTS", "PAR", "SAO", "SES", "SET", "SIX", "SZCE", "TADAWUL", "TASE", "TSX", "TSXV", "TWSE", "TYO", "VSE", "WSE"];


export const FUTURE_COMMODITY_EXCHANGE_LIST = [
  "COMEX", "CBOT", "GFTSE", "ICE", "IPE", "LME", "LMEOS", "LMEPM", "NYMEX", "SES", "GBTC", "GFX", "GSIF"
]
export const API_CONTROL_PANEL_INPUT_TYPE = {
  "TEXT_INPUT": "text_input",
  "NUMBER_INPUT": "number_input",
  "TICKER_ELASTICSEARCH_INPUT": "ticker_elasticsearch_input",
  "ONE_CHOICE": "one_choice",
  "MULTIPLE_CHOICE": "multiple_choice",
  "ACCESSKEY_TEXT_INPUT": "accesskey_text_input"
};


// WEBPACK FOOTER //
// ./src/assets/apiDocs/api_constants.js